import ChatWidgetWrapper from './ChatWidgetWrapper';

export default ChatWidgetWrapper;
